/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable max-len */
/* tslint:disable max-line-length */
const TRANSLATION_PENDING = '#translationPending';

export default {
    'The minimum stake per combination is {minimumStakePerCombination}. Your current value is {stakePerCombination}': 'Minimalna stawka na kombinację wynosi {minimumStakePerCombination}. Twoja obecna wartość to {stakePerCombination}',
    'cancel ticket': 'Anuluj kupon',
    'ticket canceled successfully': 'Kupon anulowany poprawnie',
    'ticket already canceled': 'Kupon jest anulowany',
    'wrong control code': 'Kod kontrolny {controlCode} nie jest prawidłowy dla kuponu {ticketId} .',
    'input ticket control code': 'Wprowadź kod kontrolny kuponu',
    yes: 'tak',
    'do not navigate away from this screen until the ticket is printed': 'Nie opuszczaj tego ekranu, dopóki kupon nie zostanie wydrukowany',
    'ticket reprint': 'Przedrukuj kupon',
    // check ticket translations
    // game: 'Gra',
    // ticketId: 'ID Kuponu',
    // stake: 'Wklad',
    winnings: 'Wygrana',
    // payout: 'Wyplata',
    // status: 'Stan',
    // type: 'Typ',
    bet: 'Zaklad',
    payin: 'Stawka',
    handlingFee: 'Podatek',
    payoutTax: 'Oplata',
    // code: 'Kod',
    // fix: 'Fix',
    event: 'Zdarzenie',
    // date: 'Data',
    margin: 'Margines',
    market: 'Zaklad',
    // coefficient: 'Kurs',
    ticketStatus: 'Stan kuponu',
    potentialPayoff: 'Mozliwa wygrana',
    actualPayoff: 'Akt wygrana',
    minPotential: 'Min wygrana',
    // luckyLoser: 'Lucky loser',
    // bonus: 'Bonus',
    // currency: 'PLN',
    repeatTicketMsg: 'Mozesz powtorzyc kupon z wydarzeniami, ktore sie jeszcze nie rozpoczely, naciskając ponizej zakladke.',
    inProgress: 'W TOKU',
    // active: 'Aktywny',
    // lost: 'PRZEGRANY',
    // win: 'WYGRANY',
    // refund: 'ZWROT',
    // canceled: 'Anulowany',
    // sports: 'sport',
    // lotto: 'loto',
    // check ticket translations end
    'Application initializing': 'Inicjalizacja aplikacji',
    'Maintenance in progress': 'Trwa konserwacja',
    'Ticket printed successfully': 'Udane drukowanie',
    'lucky loser candidate': 'Aktywowana Szansa',
    'Negotiating...': 'Trwają negocjacje',
    // terminal specific translations start
    insufficientFounds: 'Brak srodkow',
    enterNumber: 'Wpisz kwote',
    chooseSystems: 'WYBIERZ SYSTEM',
    // terminal specific translations end
    // printed ticket translations
    ticketId: 'Numer Kuponu',
    ticketCode: 'Kod',
    copy: 'Kopia',
    ticketType: 'Typ kuponu',
    eventsCount: 'Zdarzen',
    totalStake: 'Stawka',
    cda: 'Podatek',
    cleanStake: 'Wklad',
    totalCoefficient: 'Kurs calkowity',
    numberCombinations: 'Nr',
    minPotentialWin: 'Min wygrana',
    potentialWin: 'Wygrana [zł]',
    luckyLoser: 'Aktywowana Szansa',
    simpleTicket: 'SINGIEL/MULTI',
    systemTicket: 'SYSTEM',
    extraWinTax: 'Ekstra podatek',
    eventFix: 'PEW',
    fixLabel: 'P',
    'print ticket': 'wydrukuj kupon',
    // printed ticket translations end
    stake: 'Kwota',
    currencySymbol: '$',
    currencyAbbreviation: 'PLN',
    totalScore: 'T',
    currentPeriodScore: 'C',
    previousPeriodScore: 'P',
    G: 'G',
    S: 'S',
    M: 'M',

    '13 digit number': '13-cyfrowy numer',
    '€ 0.20 + VAT per minute': '€ 0.20 + VAT na minutę',
    'international clubs': 'kluby międzynarodowe',
    england: 'Anglia',
    'england amateur': 'Angielska amatorska',
    iceland: 'Islandia',
    ghana: 'Ghana',
    'faroe islands': 'Wyspy Owcze',
    estonia: 'Estonia',
    'denmark amateur': 'Dania amatorska',
    china: 'chiny',
    canada: 'canada',
    portugal: 'portugalia',
    cameroon: 'cameroon',
    'bosnia & herzegovina': 'Bośnia i Hercegowina',
    belarus: 'Białoruś',
    'austria amateur': 'Austria amatorska',
    armenia: 'Armenia',
    albania: 'Albania',
    malta: 'Malta',
    'germany amateur': 'Niemiecka amatorska',
    cyprus: 'cypr',
    greece: 'grecja',
    germany: 'Niemcy',
    'international youth': 'Międzynarodowe juniorskie',
    'united arab emirates': 'Zjednoczone emiraty arabskie',
    israel: 'Israel',
    kenya: 'kenya',
    philippines: 'Filipiny',
    italy: 'Włochy',
    scotland: 'Szkocja',
    'saudi arabia': 'Arabia saudyjska',
    panama: 'Panama',
    spain: 'Hiszpania',
    egipt: 'Egipt',
    jamaica: 'Jamaika',
    'south africa': 'Afryka południowa',
    finland: 'finlandia',
    france: 'francja',
    qatar: 'qatar',
    iran: 'iran',
    australia: 'australia',
    ecuador: 'ecuador',
    brazil: 'brazylia',
    chile: 'chile',
    venezuela: 'venezuela',
    mexico: 'meksyk',
    vietnam: 'vietnam',
    azerbaijan: 'azerbaijan',
    'costa rica': 'costa rica',
    honduras: 'honduras',
    'hong kong': 'hong kong',
    romania: 'rumunia',
    pakistan: 'pakistan',
    guatemala: 'guatemala',
    international: 'międzynarodowy',
    turkey: 'turcja',
    bolivia: 'bolivia',
    senegal: 'senegal',
    netherlands: 'Holandia',
    'new zealand': 'Nowa Zelandia',
    tunisia: 'Tunezja',
    wales: 'Walia',
    'czech republic': 'Republika Czeska',
    'northern ireland': 'Irlandia Północna',
    belgium: 'belgia',
    croatia: 'CHorwacja',
    'turkey amateur': 'Turecja amatorska',
    'el salvador': 'el salvador',
    colombia: 'colombia',
    austria: 'austria',
    'san marino': 'san marino',
    argentina: 'argentyna',
    switzerland: 'szwajcaria',
    macedonia: 'macedonia',
    poland: 'Polska',
    sweden: 'szwecja',
    norway: 'norwegia',
    bulgaria: 'bułgaria',
    hungary: 'Węgry',
    slovenia: 'słovenia',
    russia: 'rosja',
    slovakia: 'słowacja',
    ukraine: 'ukraina',
    serbia: 'serbia',
    denmark: 'dania',
    bahrain: 'bahrain',
    india: 'india',
    indonesia: 'indonesia',
    latvia: 'Łotwa',
    gibraltar: 'gibraltar',
    'ivory coast': 'Wybrzeże Kości Słoniowej',
    kuwait: 'kuwejt',
    andorra: 'andorra',
    paraguay: 'paragwai',
    algeria: 'algeria',
    jordan: 'jordan',
    malaysia: 'malaysia',
    singapore: 'singapore',
    ireland: 'Irlandia',
    georgia: 'georgia',
    uzbekistan: 'uzbekistan',
    usa: 'usa',
    uruguay: 'urugwaj',
    thailand: 'tailandia',
    'sweden amateur': 'szwecja amatorska',
    'south korea': 'korea południowa',
    peru: 'peru',
    oman: 'oman',
    morocco: 'moroko',
    montenegro: 'montenegro',
    moldova: 'mołdawia',
    luxembourg: 'luxemburg',
    lithuania: 'Litwa',
    liechtenstein: 'liechtenstein',
    kazakhstan: 'kazakhstan',
    japan: 'japonia',
    uganda: 'uganda',
    yemen: 'yemen',
    rwanda: 'rwanda',
    burundi: 'burundi',
    wta: 'wta',
    atp: 'atp',
    'federation cup': 'federation cup',
    'itf men': 'itf mężczyzn',
    'itf women': 'itf kobiet',
    'davis cup': 'davis cup',
    challenge: 'challenge',
    'challenge women': 'challenge women',
    'coreea de sud': 'coreea de sud',

    'about us': 'o nas',
    'about-us': 'o-nas',
    'About Superbet': 'O Superbet',
    accept: 'akceptuj',
    account: 'konto',
    'activate account': 'aktywuj konto',
    active: 'aktywuj',
    'and is available from Vodafone, Orange and Telekom networks. We will take all calls in the order they were made.': 'and is available from Vodafone, Orange and Telekom networks. We will take all calls in the order they were made.',
    'activate account success': 'Aktywacja konta zakończona powodzeniem',
    'account activated': 'konto aktywowane',
    'account status': 'status konta',
    'account balance': 'stan konta',
    'account name': 'nazwa konta',
    address: 'adres',
    'adding to your Superbet account is like any bank payment, from your online banking account or at your bank\'s counter': 'dodawanie do konta Superbet jest jak każda płatność bankowa, z konta bankowego online lub w kasie banku.',
    'agencies need': 'agencies need',
    'agree to terms and conditions': 'agree to terms and conditions',
    'age warning': 'Dostęp dla osób poniżej 18 roku życia jest surowo zabroniony.',
    all: 'wszystko',
    'all types': 'wszystkie typy',
    'all games': 'wszystkie gry',
    'all sports': 'wszystkie sporty',
    'all tournaments': 'wszystkie turnieje',
    'all markets': 'wszystkie podgry',
    'all offer': 'cała oferta',
    'all news': 'wszystkie nowości',
    alerts: 'alerty',
    amount: 'ilość',
    'Anti-laundering money policy': 'Polityka przeciwdziałania praniu pieniędzy',
    'available amount': 'dostępna ilość',
    agency: 'punkt',
    'agency list': 'lista punktów',
    'agency withdrawal': 'wypłata w punkcie',
    agencies: 'punkty',
    articles: 'artykuły',
    'authenticated for': 'uwierzytelniony dla',
    'agencies-content': 'agentii',
    'all lottery': 'cała loteria',
    'agency locations': 'lokalizacja punktu',

    back: 'wróć',
    'back to offer': 'wróć do oferty',
    bank: 'bank',
    'bank transfer': 'Transfer bankowy',
    'bank transfer deposits': 'wpłaty przelewem bankowym',
    betSlip: 'kupon',
    'Betslip is empty. Select events from offer and place your bet.':
        'Kupon jest pusty. Wybierz wydarzenia z oferty aby postawić swój zakład.',
    bets: 'zakłady',
    'bet id': 'id zakładu',
    'bets history': 'historia zakładów',
    'betting promotions': 'Promocje',
    bonus: 'Bonus',
    'bonus-bun-venit-sport': 'bonus-powitalny-sport',
    'bonus-bun-venit-casino': 'bonus-powitalny-kasyno',
    'bonus terms & conditions': 'Regulamin',
    besix: 'besix',
    'besix results': 'besix results',
    'browse files': 'wyszukaj pliki',
    'bets info': 'informacje o zakładach',
    'bookie changed the bet, do you accept?': 'bukmacher zmienił zakład, akceptujesz go?',
    'bonuses promotions': 'promocje bonusów',
    'bonuses-promotions': 'promocje-bonusów',

    'cancellation failed': 'anulowanie nie powiodło się',
    cancel: 'anuluj',
    canceled: 'anulowany',
    'cancel withdrawal': 'anuluj wypłatę',
    'canceling the transaction failed': 'anulowanie transakcji nie powiodło się',
    casino: 'kasyno',
    'casino history': 'historia kasyna',
    'Casino is currently under maintenance': 'Kasyno jest obecnie w trakcie konserwacji',
    cashInstantWithdrawalNotice1: 'Cash-Instant pozwala wypłacić do ',
    cashInstantWithdrawalNotice2: '400 PLN na dzień. ',
    cashInstantWithdrawalNotice3: 'W przypadku większych kwot skorzystaj z opcji Online lub opcji punktu.',
    'casino live': 'kasyno live',
    'Casino Live - Blackjack, Roulette': 'Casino Live - blackjack, ruletka',
    cash: 'gotówka',
    'casino plays': 'gry w kasynie',
    careers: 'kariery',
    'check your events, you have errors': 'sprawdź swoje wydarzenia, posiadasz błędy',
    'Changed from {oldValue} to {newValue}': 'Zmieniono z {oldValue} na {newValue}',
    'check ticket': 'sprawdź kupon',
    'change password': 'zmień hasło',
    'change phone': 'zmień numer telefonu',
    'choose bonus now and deposit': 'wybierz bonus już teraz i wpłać',
    'Choose from the list below the agency you prefer to withdraw your money. In the next 24 hours, you will be able to cash in the selected agency.': 'Wybierz z poniższej listy lokalizację, w której preferujesz wypłacić. W ciągu następnych 24 godzin będziesz mógł dokonać wypłaty w wybranej lokalizacji.',
    'choose bonus': 'wybierz bonus',
    'change URL sent to your E-mail': 'zmień adres URL wysłany na Twój adres e-mail',
    'close the preview': 'zamknij podgląd',
    city: 'miasto',
    cities: 'miasta',
    'Choose your bonus before deposit': 'wybierz swój bonus przed wpłatą',
    close: 'zamknij',
    'Close All': 'Zamknij Wszystko',
    combinations: 'kombinacje',
    CNP: 'Pesel',
    'code sent successfully': 'kod wysłany pomyślnie',
    confirm: 'potwierdź',
    collapse: 'collapse',
    country: 'kraj',
    combination: 'kombinacja',
    competitors: 'konkurenci',
    'consimtamant-gdpr': 'zgoda-RODO',
    'choose sport and tournament first': 'najpierw wybierz sport i turniej',
    'combinations count': 'kombinacje się liczą',
    'choose date': 'wybierz datę',
    code: 'kod',
    'code to validate withdrawal in agency': 'kod weryfikujący wypłatę w punkcie',
    'confirm reset': 'potwierdź reset',
    continue: 'dalej',
    coefficient: 'współczynnik',
    county: 'kraj',
    create: 'utwórz',
    'create account': 'utwórz konto',
    'choose GDPR': 'wybierz RODO',
    currency: 'waluta',
    'current number': 'aktualny numer',
    'currently under maintenance': 'Obecnie w trakcje przebudowy',
    'cup roster': 'lista pucharów',
    'Currently you have no active bets': 'Obecnie nie masz aktywnych zakładów',
    'Choose from the list below the agency you prefer to withdraw your money. In the next 24 hours, you will be able to cash in the selected agency': 'Wybierz z poniższej listy punkt, w którym preferujesz wypłacić. W ciągu następnych 24 godzin będziesz mógł dokonać wypłaty w wybranym punkcie',

    // D
    days: 'dni',
    date: 'data',
    'data protection': 'ochrona danych',
    'daily offer': 'oferta dzienna',
    'daily lotto offer': 'dzienna oferta lotto',
    'time remaining': 'pozostały czas',
    decline: 'Odrzuć',
    'Dear Customers, according to OUG 18 of March 15, 2018, as of March 24, 2018, the tax due for withdrawals from online gaming accounts, amounting to 1% (for amounts up to 66750 RON) of the withdrawn amount, is also determined is retained at source.': 'Drodzy klienci, zgodnie z 18 OUG z 15 marca 2018 r., Z dniem 24 marca 2018 r., Określa się również podatek należny za wypłaty z kont gier online, wynoszący 1% (w przypadku kwot do 66750 RON) wypłaconej kwoty jest zatrzymany u źródła.',
    demo: 'demo',
    deposit: 'wpłata',
    details: 'szczegóły',
    'deposit and withdraw through agencies, no commission!': 'wpłacaj i wypłacaj za pośrednictwem punktu bez prowizji!',
    'deposit.tax': 'Drodzy klienci, zgodnie z nadzwyczajnym rozporządzeniem rządu 114 z 28.12.2018 w sprawie środków fiskalno-budżetowych, od teraz na wasze konto online będą naliczane opłaty za zarządzanie w wysokości 2% za depozyt.',
    'Deposit Online': 'Wpłata Online',
    'deposit by bank transfer, free of charge': 'wpłać przelewem, bezpłatnie!',
    'deposit and withdraw through agencies, no commission': 'wpłaty i wypłaty za pośrednictwem punktu, bez prowizji',
    'details of': 'szczegóły',
    'details on': 'szczegóły na',
    'details about online withdrawal': 'szczegóły dotyczące wypłąty online',
    'details about agency deposits': 'szczegóły dotyczące wpłat na punkcie',
    'details about paysafecard deposit': 'szczegóły wpłaty przy użyciu metody paysafecard',
    'details of bank transfer deposits': 'szczegóły wpłat metodą przelewu',
    'deposit request': 'wniosek o depozyt',
    'deposit response': 'odpowiedź na depozyt',
    'Deposit in the agency and you will have your money in your account instantly and at no commission! You can only withdraw from the agency if the deposit method was through the agency': 'Dokonaj wpłaty w punkcie, a będziesz mieć swoje pieniądze na koncie natychmiast i bez prowizji! Możesz wypłacić pieniądze z agencji tylko wtedy, gdy metoda wpłaty przeszła przez punkt',
    'don\'t have account': 'Nie masz konta',
    'display name': 'wyświetlana nazwa',
    'Direct withdrawal to the user\'s bank account.': 'Bezpośrednia wypłata na konto bankowe użytkownika.',
    'details of your Romainian residence for regulatory purposes': 'szczegółowe informacje na temat twojego pobytu w Polsce do celów prawnych',
    'details about online deposits': 'szczegóły dotyczące depozytów online',
    'details about bank transfer deposits': 'szczegóły dotyczące depozytów przelewem bankowym',
    disclaimer: `Obowiązkiem każdego gracza jest działanie
     zgodnie z obowiązującymi przepisami oraz
     naszym regulaminie. Hazard
     wiąże się z ryzykiem, graj ostrożnie.`,
    'Do not forget to write down the code! To raise money, we expect you on {date} at the selected agency. Money can be picked up during the agencies\' program. Please observe the withdrawal period.': 'Nie zapomnij zapisać kodu! Aby zebrać pieniądze, oczekujemy Cię w dniu {date} w wybranej punktu. Pieniądze można odebrać podczas programu punktu. Proszę przestrzegać okresu karencji.',
    'dog race results': 'wyniki wyścigu psów',
    'Document limit exceeded. Please contact our support': 'Przekroczono limit dokumentu. Skontaktuj się z naszym wsparciem',
    dogs: 'psy',
    'Do you want to move to the next round?': 'Czy chcesz przejść do następnej rundy?',
    'document not supported': 'dokument nie wspierany',
    'document upload': 'przesyłaie dokumentów',
    'confidence-declaration': 'deklaracja-poufności',
    'declaratia-de-confidentialitate': 'polityka-prywatnosci',
    'drag and drop the image here': 'Przeciągnij i upuść obraz tutaj',

    'First 3 deposits will get you bonuses of up to 500 lei': 'Pierwsze 3 wpłaty zapewnią ci bonus do 500 zł',
    'We double your first deposit up to 500 lei': 'Podwajamy twoją pierwszą wpłatę do 500 zł',
    edit: 'edytuj',
    'enter the amount': 'wprowadź kwotę',
    'Enter the email address of your Superbet account and you will receive the password reset link from the email box.':
        'Wprowadź e-mail swojego konta Superbet, a następnie ustaw nowe hasło ',
    'Enter the SMS code to validate the phone number': 'Wprowadź otrzymany kod SMS aby zweryfikować numer telefonu',
    'enter home address': 'wprowadź adres domowy',
    'Enter the amount you want to deposit.': 'Wprowadź kwotę którą chcesz wpłacić.',
    'Enter the amount you want to deposit. In the next step you will be asked which method you prefer to feed your account.': 'Wprowadź kwotę którą chcesz wpłacić. W następnym kroku zostaniesz zapytany o preferowaną przez ciebie metodę płatności.',
    'edit profile information': 'edytuj informacje na profilu',
    'Enter the code and see if you won': 'Wprowadź kod i sprawdź czy wygrałeś',
    'E-mail': 'E-mail',
    'E-mail not found': 'E-mail nie został odnaleziony',
    'enjoy the game': 'ciesz się grą!',
    'event name': 'nazwa wydarzenia',
    events: 'wydarzenia',
    'event/odd is blocked': 'wydarzenie/kurs jest zablokowany',
    'event has finished': 'wydarzenie się zakończyło',
    expand: 'poszerzać',
    explore: 'odkryj',
    error: 'error',
    errors: 'errors',

    FAQ: 'FAQ',
    for: 'dla',
    favourites: 'ulubione',
    'favourite tournaments': 'ulubione turnieje',
    'fetching data': 'pobieranie danych',
    finished: 'zakończony',
    'filter shops': 'filtruj punkty',
    filter: 'filtr',
    'first name': 'Imie',
    fiveMostRare: 'pięć najrzadszych',
    fiveMostFrequent: 'pięć najczęstszych',
    'file successfully sent': 'plik wysłany pomyślnie',
    fix: 'napraw',
    fixed: 'naprawiony',
    'Feel free to make your ticket and explore the site. You will be required to fill in all the missing information and deposit it with your first bet ': 'Sprawdź naszą stronę i przygotuj swój pierwszy kupon. Przed pierwszym zakładem będziesz musiał założyć konto i zdeponować środki. ',
    'find the nearest shop': 'znajdź najbliższy punkt sprzedarzy',
    'file size is limited to': 'rozmiar pliku jest ograniczony do',
    'forgot password': 'zapomniałeś hasła',
    friday: 'piątek',

    help: 'pomoc',
    'Important: The number of WhatsApp is exclusive to chat. The Superbet operator will respond to you in writing.': 'Ważne: numer WhatsApp jest przeznaczony wyłącznie do czatu. Operator Superbet odpisze do Ciebie.',
    'help!': 'pomoc!',
    'here you can track the history of all deposit and withdrawal transactions': 'tutaj możesz śledzić całą historię transakcje wpłat i wypłat',
    'here you can track the history of all casino transactions.': 'tutaj możesz śledzić historię transakcji kasyna ',
    'here you can track the history of all sport and lotto bets': 'tutaj możesz śledzić całą historię zakładów',
    'here you can track the history of all casino plays': 'here you can track the history of all casino plays',
    'help-url': 'pomoc',
    'hide password': 'ukryj hasło',
    'highest winning': 'najwyższa wygrana',
    history: 'historia',
    hours: 'godziny',
    hour: 'brak godzin | jedna godzina | {count} godzin',
    H2H: 'H2H',

    games: 'gry',
    'Games are currently under maintenance': 'Gry sa obecnie w trakcie konserwacji',
    'Games - slot machines, poker, roulette': 'Gry - automaty do gry, poker, ruletka',
    'game rules': 'zasady gry',
    good: 'dobrze',
    'go to withdrawal': 'idź do wypłaty',
    'greyhound races': 'wyścigi chartów',
    'greyhound retail': 'wyścigi chartów PPZ',
    'greyhound virtual': 'wirtualne charty',
    'gaming-rules': 'regulamin gry',
    game: 'gra',
    'game currently unavailable': 'gra chwilowo niedostępna',
    'GDPR consent': 'Zgoda RODO',
    genericTicketSubmitError: 'Tworzenie kuponu nie powiodło się. Proszę spróbuj ponownie. Jeśli błąd będzie się powtarzał, skontaktuj się z pomocą techniczną.',
    gamesUnavailableError: 'Gra chwilowo niedostepna!  Nie możesz dodać tej gry do ulubionych. Spróbuj ponownie później',

    IBAN: 'IBAN',
    'I accept automatic quota update': 'Akceptuję automatyczną aktualizację kwot',
    'if it is not correct': 'jeśli to nie jest poprawne',
    'identity document verification': 'weryfikacja dokumentu tożsamości',
    'identity document confirm': 'potwierdzenie dkomumentu tożsamości',
    'if you have any questions': 'jeśli masz jakieś pytania',
    'I\'ll do that later': 'Zrobię to później',
    'If you encounter other problems, we are here to': 'Jeśli napotkasz inne problemy, jesteśmy tutaj, żeby ',
    'instant withdrawal': 'natychmiastowa wypłata',
    info: 'info',
    'Info for contacting you. Enables you to effortlesly access your funds, account settings and our support': 'Informacje do skontaktowania się z Tobą. Umożliwia ci to łatwy dostęp do funduszy, ustawień konta i naszego wsparcia',
    'if you have any problems with withdrawal don\'t hesitate to contact us': 'jeśli masz jakiekolwiek problemy z wypłatą, nie wahaj się z nami skontaktować',
    'if you have any problems with deposit don\'t hesitate to contact us': 'jeśli masz jakiekolwiek problemy z wpłatą, nie wahaj się z nami skontaktować',
    'invalid username or password': 'Nieprawidłowa nazwa użytkownika lub hasło',
    'invalid file type (allowed: {extensions})': 'nieprawidłowy typ pliku  (dozwolone: {extensions})',
    '{amount} {currency} in game': '{amount} {currency} w grze',
    'in play': 'w grze',
    'in progress': 'w trakcie',
    'it is not possible to combine same market': 'nie można połączyć tych samych podgier',
    'It is not possible to combine this event with events you already have on your betslip':
        'Nie można połączyć tego wydarzenia z wydarzeniami, które już masz na kuponie',
    'It is not possible to combine this market with markets you already have on your betslip':
        'Nie można połączyć tej podgry z zakładami, które już masz na kuponie',
    'It is not possible to combine this with events you already have on your betslip':
        'Nie można połączyć tego z wydarzeniami, które już masz na kuponie',
    'I agree with the use of my personal data by Superbet through the means of communication provided to receive newsletters about general offers related to relevant products, campaigns or services.': 'Wyrażam zgodę na przetwarzanie moich danych osobowych przez Superbet zakłady bukmacherskie Spółka z o.o. w celach marketingowych, w tym poprzez profilowanie w celu określenia moich preferencji i przedstawienia mi adekwatnej i zindywidualizowanej oferty świadczonych usług. Udzieloną zgodę mogę w każdym czasie wycofać. Zapoznałem się z zasadami przetwarzania moich danych zawartych w',
    'I agree with the use of my personal data by Superbet to receive, through the means of communication made available based on my player profile analysis and opinion polls in this regard, personalized offers about promotions and / or bonuses.': 'Wyrażam zgodę na wykorzystanie moich danych osobowych przez Superbet w celu otrzymywania, za pomocą środków komunikacji udostępnionych na podstawie analizy mojego profilu gracza i badań opinii w tym zakresie, spersonalizowanych ofert dotyczących promocji i / lub bonusów.',
    'I am 18 years old. I have read, understand and agree to the': 'Mam 18 lat. Przeczytałem, rozumiem i zgadzam się na',
    'registration.terms': 'Oświadczam, że ukończyłem/łam 18 lat, zapoznałem/łam się z treścią i akceptuję postanowienia  {terms}',
    'It has been more than 3 months since you played this ticket, it\'s details are no longer available, but you can still see the status and the gain.': 'Minęły ponad 3 miesiące, odkąd zagrałeś w ten bilet, jego szczegóły nie są już dostępne, ale nadal możesz zobaczyć status i zysk.',

    jackpot: 'jackpot',
    'joc-responsabil#18+': 'odpowiedzialna-gra#18+',

    // L
    'last name': 'nazwisko',
    'last winner': 'ostatni zwycięzca',
    'Latest news in world of sport': 'Najnowsze wiadomości ze świata sportu',
    'live bet': 'zakład live',
    'Live video stream avaliable': 'Streaming na żywo dostępny',
    like: 'like',
    'live betting': 'zakłady live',
    live: 'live',
    'length should be {value}': 'długość powinna wynosić {value}',
    lost: 'przegrany',
    'live results': 'wyniki live',
    'Live betting is currently under maintenance': 'Zakłady live są obecnie w trakcie konserwacji',
    'list of shops': 'lista punktów',
    lottery: 'loteria',
    'lottery results': 'wyniki loteri',
    login: 'zaloguj',
    logout: 'wyloguj',
    'Login to Account': 'Zaloguj się na konto',
    loading: 'ładuję',
    'load more': 'załaduj więcej',
    'Lottery betting - Greece Kino, Win for Life, Numerone': 'Zakłady na loterię - Grecja Kino, Win for Life, Numerone',
    'lotto types': 'rodzaje lotto',
    'lotto games': 'gry lotto',
    'Lotto is currently under maintenance': 'Lotto jest obecnie w trakcie konserwacji',
    'lucky six': 'lucky six',
    'lucky x': 'lucky x',
    'luckysix retail': 'luckysix retail',
    lineups: 'składy',
    'Live Chat': 'Live Chat',
    'live events are not allowed on offline betSlip': 'wydarzenia na żywo nie są dozwolone na kuponach zakładów offline',
    lotteries: 'loterie',
    lotto: 'lotto',
    'login to watch video': 'zaloguj się, aby obejrzeć wideo',

    'Know your user pending': 'Poznaj swojego użytkownika w toku',

    'main market not available, click to': 'główny zakład niedostępny, kliknij, aby',
    'see more markets': 'zobacz więcej zakładów',
    'maximum number of rest events reached': 'osiągnięta maksymalna liczba zdarzeń odpoczynku',
    'Watch match on TV': 'Obejrzyj mecz w telewizji',
    mastercard: 'mastercard',
    matches: 'mecze',
    markets: 'zakłady',
    'markets temporary locked': 'zakłady tymczasowo niedostępne',
    maintenance: 'konserwacja',
    'metode-de-plata#agentii': 'metoda-płatności#punkt',
    'metode-de-plata-online#visa-master': 'metoda-płatności-online#visa-master',
    'metode-de-plata-online#skrill': 'metoda-płatności-online#skrill',
    'metode-de-plata-online#neteller': 'metoda-płatności-online#neteller',
    'metode-de-plata-online#paysafecard': 'metoda-płatności-online#paysafecard',
    message: 'wiadomość',
    'make an online deposit': 'wykonaj wpłatę online',
    'make a deposit': 'make a deposit',
    'make a deposit with paysafecard': 'wpłać przy użyciu paysafecard',
    'max {count} numbers': 'max {count} numerów',
    'maximum number of selections reached': 'osiągnięto maksymalną liczbę wyborów',
    'maximum length is {value}': 'maksymalna długość to {value}',
    'maximum is {value}': 'maximum to {value}',
    'match details': 'szczegóły meczu ',
    'minimum potential win': 'minimalna potencjalna wygrana',
    'minimum is {value}': 'minimum to {value}',
    'minimum stake on ticket raised': 'minimalna stawka na kuponie wzrosła',
    'minimum system to select is {minNumber}/{fromNumber}': 'minimalny system do wyboru to {minNumber}/{fromNumber}',
    'minimum length is {value}': 'minimalna długość to {value}',
    'Minimum stake is {minimumStake}': 'Minimalna stawka wynosi {minimumStake}',
    'min potential gain': 'min potencjalna zysk',
    'min potential win': 'Min mozliwa wygrana',
    'Maximum stake is {maximumStake}': 'Maksymalna stawka to {maximumStake}',
    'maximum file size is {value}': 'maksymalny rozmiar pliku to {value}',
    'my bets': 'moje zakłady',
    monday: 'poniedziałek',
    'more information': 'więcej informacji',
    modifications: 'modyfikacje',
    'my account': 'moje konto',
    'my numbers': 'moje liczby',
    'my tickets': 'moje kupony',
    'my picks': 'moje typy',
    'max 16 numbers': 'max 16 liczb',
    'maximal win amount of {maxWinAmount} reached': 'Maksymalna wygrana {maxWinAmount} została osiągnięa.',
    'potential winning amount lower than the stake': 'Potencjalna wypłata niższa stawka',
    'win amount too small, minimal is {minWinAmount}': 'Wygrana za mała, minimalna to {minWinAmount}',
    minimize: 'zminimalizuj',

    'N/A': 'N/A',
    name: 'imie',
    news: 'nowości',
    'new potential win': 'nowa potencjalna wygrana',
    'new password': 'nowe hasło',
    neteller: 'neteller',
    'need help to make a deposit': 'potrzebuję pomocy, aby dokonać wpłaty',
    'need help to make a withdrawal': 'potrzebuję pomocy, aby dokonać wypłaty',
    'no available markets': 'brak dostępnych zakładów',
    'no data': 'brak danych',
    'no transactions': 'brak transakcji',
    'no events for this team name exist in this time period': 'w tym okresie nie ma żadnych wydarzeń dla tej nazwy zespołu',
    'no results found for': 'Nie znaleziono wyników dla',
    'not now': 'nie teraz',
    'not found': 'nie znaleziono',
    '404 - page not found': '404 - page not found',
    'but you’re still a winner!': 'ale nadal jesteś zwycięzcą!',
    'and your prize: an amazing sport fact you probably didn’t know.': 'I twoja nagroda: niesamowity fakt sportowy, którego prawdopodobnie nie znasz.',
    'next six': 'następne sześć',
    'New Password': 'Nowe Hasło',
    'no active statistics': 'brak aktywnych statystyk',
    'no markets currently available': 'brak dostępnych zakładów',
    'not valid E-mail': 'nie prawidłowy E-mail',
    'nothing to retract.': 'Nic do wycofania.',
    new: 'nowy',
    next: 'nastepny',
    'next round': 'nastepna runda',
    'NON-STOP': 'NON-STOP',
    number: 'liczba',
    'number randomizer': 'number randomizer',
    numbers: 'liczby',
    'number of winners': 'liczba zwycięzców',
    'number of lotto balls': 'liczba piłek lotto',
    'number of combinations': 'liczba kombinacji',
    'no bonus': 'brak bonusu',
    'no events on ticket': 'brak zdarzeń na kuponie',
    'no favourite numbers saved for this game yet': 'nie zapisano jeszcze ulubionych liczb dla tej gry',

    'odds tolerance': 'tolerancja kursów',
    odds: 'kursy',
    offer: 'oferta',
    offline: 'offline',
    'offline ticket': 'kupon offline',
    ok: 'ok',
    'old password': 'stare hasło',
    online: 'online',
    'only images are allowed': 'dozwolone są tylko obrazy',
    'online withdrawal': 'wypłata online',
    'online-payments': 'metoda-płatności-online',
    'Option to withdraw users on credit card.': 'Możliwość wypłaty środków na kartę kredytową.',
    or: 'lub',
    other: 'inny',
    'other deposit options': 'inne opcje wpłaty',
    'our withdrawal has been canceled!': 'Nasza wypłata została anulowana!',

    payout: 'wypłata',
    payoff: 'wypłata',
    password: 'hasło',
    'page not authorized': 'strona nie autoryzowana',
    'page not found': 'nie odnaleziono strony',
    'password strength': 'siła hasła',
    'password update': 'aktualizacja hasła',
    'password changed': 'hasło zmienione',
    'password recovery': 'hasło przywrócone',
    payment: 'płatność',
    'payment description': 'opis płatności',
    paysafecard: 'paysafecard',
    'Part of the offer is unavailable during this maintenance': 'Część oferty jest niedostępna podczas konserwacji',
    'payment reference': 'referencje płatności',
    'Password changed. You can now login': 'Hasło zostało zmienione. Teraz możesz się zalogować',
    pending: 'w toku',
    'pending withdrawals': 'wypłata w toku',
    phone: 'telefon',
    'phone number validation': 'sprawdzanie poprawności numeru telefonu',
    'Pinned Events': 'przypięte wydarzenia',
    play: 'graj',
    'Please do not call us at this number.': 'Prosimy nie dzwonić do nas pod ten numer.',
    played: 'rozegrany',
    'play now': 'graj teraz',
    'played combinations': 'zagrane kombinacje',
    'please contact our support': 'skontaktuj się z naszym wsparciem',
    'player stats': 'statystyki gracza',
    'play video': 'odtwórz wideo',
    'pick county': 'wybierz kraj',
    'pick your city': 'wybierz swoje miasto',
    place: 'miejsce',
    'please refresh your page': 'Odśwież stronę',
    'please select at least one combination': 'proszę wybrać przynajmniej jedną kombinację',
    'Please enter a new password and confirm your changes.': 'Wprowadź nowe hasło i potwierdź zmiany.',
    'Placing bet...': 'Stawianie zakładu...',
    'potential win': 'Mozliwa wygrana',
    // 'potential win': 'potencjalna wygrana',
    'potential gain': 'potencjalny zysk',
    'potential bonus percentage': 'potencjalny procent bonusu',
    'potential bonus value': 'potencjalna wartość bonusu',
    'potential bonus': 'potencjalny bonus',
    popular: 'popularny',
    'politica-impotriva-spalarii-banilor': 'Polityka-przeciwdziałania-praniu-pieniędzy',
    print: 'punkt',
    profile: 'profil',
    'promotii-bonusuri': 'promocje-bonusowe',
    previous: 'poprzedni',
    'profile page': 'strona profilowa',
    'bet now': 'postaw teraz',
    'some odds have changed, press bet now to accept': 'Niektore kursy ulegly zmianie, nacisnij ponownie aby zaakceptowac zaklad',
    'put more events of same market': 'umieść więcej zdarzeń z tej samy grupy zakładów',
    'put more events of other markets': 'umieść więcej zdarzeń z innej grupy zakładów',
    'preferred shops': 'Preferowane punkty',
    'paySafe card': 'paySafe card',
    'payment-method-bank-transfer': 'metoda-płatności-transfer-bankwoy',
    'payment-method-online': 'metoda-płatności-online',
    'metode-de-plata-transfer-bancar': 'metoda-płatności-transfer-bankowy',
    'payment-method': 'metoda-płatności',
    'payment-method-agency': 'metoda-płatności',
    'previuos match result': 'poprzedni wynik meczu',
    payed: 'zapłacony',
    'payment stuff': 'płatności',

    'quick choice': 'szybki wybór',

    real: 'rzeczywisty',
    'resend SMS': 'wyślij ponownie SMS',
    'Reject all bonus choices': 'Odrzuć wszystkie opcjie bonusów',
    recommended: 'polecany',
    register: 'Zarejestruj',
    'remove all': 'usuń wszystko',
    reset: 'reset',
    read: 'przeczytaj',
    refund: 'zwrot',
    'resolved tickets': 'rozstrzygnięte kupony',
    'responsible gaming': 'odpowiedzialna gra',
    'results for': 'wyniki dla',
    results: 'wyniki',
    'Results of sport events, lotto events': 'Wyniki wydarzeń sportowych, lotto',
    'Results are currently under maintenance': 'Wyniki są obecnie w trakcie konserwacji',
    result: 'wynik',
    recreate: 'odtwórz',
    'retract funds': 'wycofaj fundusze',
    retry: 'spróbuj ponownie',
    'registration.intro': 'Aby zarejestrować się w Superbet, musisz przeczytać, zrozumieć i zaakceptować {terms} a także czytać, rozumieć i zaakceptować {statement}',
    'Rules of the game. And of course the way we protect and proccess your data': 'Zasady gry. I oczywiście sposób, w jaki chronimy i przetwarzamy twoje dane',
    'responsible-gaming': 'odpowiedzialna-gra',
    'rounds with appearance': 'brał udział w rundach',
    'rounds without appearance': 'rundy bez udziału',
    'random numbers': 'losowe liczby',
    'resume video': 'wznów wideo',

    saturday: 'sobota',
    'save favourites': 'zapisz ulubione',
    save: 'zapisz',
    'scan with your m-banking app': 'skanuj za pomocą aplikacji m-banking',
    search: 'wyszukaj',
    selected: 'wybrane',
    'selected numbers': 'wybrane liczby',
    'selected odd doesn\'t exist anymore': 'wybrany kurs już nie istnieje',
    'selected odd is unavailable': 'wybrany kurs jest niedostępny',
    send: 'wyślij',
    'see older': 'zobacz starsze',
    'sending sms failure': 'wysyłanie wiadomości SMS nie powiodło się',
    'session duration': 'czas trwania sesji',
    settings: 'ustawienia',
    'search events': 'wyszukaj zdarzenia',
    shop: 'punkt',
    shops: 'punkty',
    'shop deposits': 'wpłata na punkcie',
    'Send us a color picture of your identity cards and complete the account verification procedure. Otherwise the law requires us to close the account': 'Wyślij nam kolorowe zdjęcie swoich dokumentów tożsamości i zakończ procedurę weryfikacji konta. W przeciwnym razie prawo wymaga od nas zamknięcia konta',
    simple: 'prosty',
    'single ticket': 'kupon single',
    'show password': 'pokaż hasło',
    skrill: 'skrill',
    slots: 'automaty',
    'sms sent': 'sms wysłany',
    'sms limit reached': 'limit sms osiągnięty',
    'show more': 'pokaż więcej',
    'Show All': 'Pokaż Wszystko',
    'show all transactions': 'pokaż wszystkie transakcje',
    'long info': `Superbet zakłady bukmacherskie Sp. z o.o., z
     siedzibą: ul. 73 Pułku Piechoty 7A, 40-496 Katowice, zarejestrowana przez Sąd Rejonowy Katowice - Wschód
    w Katowicach Wydział VIII Gospodarczy Krajowego Rejestru Sądowego pod nr KRS 0000666114, Regon: 366704393, NIP: 9542775133 `,
    'Something went wrong. Please try again': 'Coś poszło nie tak. Spróbuj ponownie',
    'Sorry, the time to play this round has expired.': 'Przepraszamy, upłynął czas na gre w tej rundzie.',
    special: 'special',
    specials: 'specjalne',
    'sport bets': 'zaklady prematch',
    'lotto bets': 'zakłady lotto',
    'virtual bets': 'zakłady wirtualne',
    'special bets': 'zakłady specjalne',
    'specials results': 'wyniki specjali',
    'Specials are currently under maintenance': 'Specjalne są obecnie w trakcie konserwacji',
    sports: 'Sporty',
    sport: 'sport',
    'Special bets only at Superbet': 'Zakłady specjalne tylko w Superbet',
    'Sports and live betting': 'Zakłady prematch i live',
    // stake: 'stawka',
    'stake after tax': 'stawka po opodatkowaniu',
    status: 'stan',
    statistics: 'statystyki',
    string: 'string',
    'sport results': 'wyniki prematch',
    'statistics unavailable': 'Statystyki niedostępne',
    'statistical combinations': 'kombinacje statystyczne',
    'successfully withdrawn': 'pomyślnie wycofane',
    sunday: 'niedziela',
    success: 'sukces',
    submit: 'prześlij',
    'super offer': 'super oferta',
    'submit failed': 'przesyłanie nie powiodło się',
    'submit for verification': 'przesłać do weryfikacji',
    'successful password change': 'udana zmiana hasła',
    'super kvota': 'super kvota',
    'super extra': 'super extra',
    'Super Extra must be combined with at least {minNonPromotionalSelection} other events with a minimum odd {minNonPromotionalOdd}': 'Super Extra należy połączyć przynajmniej z {minNonPromotionalSelection} inne zdarzenia z minimalnym kursem {minNonPromotionalOdd}',
    system: 'system',
    systems: 'systemy',
    'show ball statistics': 'pokaż statystyki piłek',
    SWIFT: 'Szybki',
    'Superbet terms and conditions': 'Regulamin Superbet',
    'Superbet Confidentiality Statement': 'Oświadczenie o poufności Superbet',

    'this is the entire offer for this competition': 'to cała oferta dla tego zdarzenia',
    'this is the entire offer for': 'to cała oferta dla',
    ticket: 'kupon',
    tickets: 'kupony',
    'ticket not found': 'nie odnaleziono kuponu',
    teams: 'zespoły',
    tax: 'podatek',
    taxPerc: 'podatek {taxPercentage}%',
    table: 'tabela',
    'table games': 'gry stołowe',
    tables: 'tabele',
    'Terms and Conditions': 'Regulamin',
    'Thank you for trusting us. Your account has been successfully verified.': `Dziękujemy za zaufanie.
         Twoje konto zostało pomyślnie zweryfikowane.`,
    'There are currently no bets available': 'Obecnie nie ma dostępnych zakładów',
    'These are all news related to events and competitions': 'Są to wszystkie wiadomości związane z wydarzeniami i konkursami',
    threeMostFrequent: 'trzy najczęściej',
    'The phone number has a single rate of': 'Numer telefonu ma jedną stawkę',
    'The transaction will be processed as soon as possible.': 'Transakcja zostanie przetworzona jak najszybciej.',
    'the SMS code': 'kod SMS',
    'the next round begins in': 'następna runda rozpoczyna się za',
    'There seems to be a problem of canceling the transaction. Try again or contact our support, we\'re here to help!': 'Wydaje się, że występuje problem z anulowaniem transakcji. Spróbuj ponownie lub skontaktuj się z naszym wsparciem, jesteśmy tutaj, aby pomóc!',
    'try again': 'spróbuj ponownie',
    'this field is required': 'to pole jest wymagane',
    'this field must be a number': 'to pole musi być liczbą',
    'this field must be larger than {value}': 'to pole musi być większe niż {value}',
    'this field must be smaller than {value}': 'to pole musi być mniejsze niż {value}',
    'this is the entire offer for this competition.': 'to cała oferta tego konkursu.',
    'The image is successfully uploaded': 'Obraz został pomyślnie przesłany',
    threeMostConsecutive: 'trzy najbardziej kolejne',
    thursday: 'czwartek',
    'This event requires that you add {minNonPromotionalSelection} more events with odd even or greater than {minNonPromotionalOdd}': 'To wydarzenie wymaga dodania {minNonPromotionalSelection} więcej wydarzeń z kursem równym lub większą niż {minNonPromotionalOdd}',
    'The registration form was sent successfully. Check your e-mail and complete the registration process. Thank you': 'Formularz rejestracyjny został wysłany pomyślnie. Sprawdź swój adres e-mail i zakończ proces rejestracji. Dziękujemy',
    'tickets in progress': 'tickets in progress',
    time: 'czas',
    type: 'typ',
    types: 'typy',
    'There was some problems, please contact our support': 'Wystąpiły problemy, skontaktuj się z naszym wsparciem',
    title: 'tytuł',
    today: 'dzisiaj',
    tomorrow: 'jutro',
    'total quota': 'Calkowity kurs',
    // 'total quota': 'całkowita kwota',
    'top ten': 'top 10',
    'transactions history': 'historia transakcji',
    tournaments: 'turnieje',
    'tournament details': 'szczegóły turnieju',
    transactions: 'transakcje',
    'transaction succeed': 'transakcja zakończona pomyślnie',
    'transaction status': 'status transakcji',
    'transaction pending': 'transakcja w toku',
    'transaction failed': 'transakcja nie powiodłą się',
    'transaction canceled': 'transakcja anulowana',
    tuesday: 'wtorek',
    'turnover till cashout': 'obrót do cashout',
    twoMostFrequent: 'dwa najcześciej',
    twoMostConsecutive: 'dwa kolejne z rzędu',
    'terms-and-conditions': 'regulamin',
    'time left': 'pozostay czas',

    undo: 'cofnij',
    unlike: 'w odróżnieniu',
    'unpin all': 'odepnij wszystkie',
    upcoming: 'nadchodzące',
    username: 'nazwa użytkownika',
    'user balance to low': 'Bilans użytkownika za niski',
    'upload a document photo': 'prześlij zdjęcie dokumentu',
    'Upload or take a color photo of your identity card. After the successful upload, we will check if everything is correct, and we will send you the confirmation or the next steps to complete the verification process': 'Prześlij lub zrób kolorowe zdjęcie swojego dowodu osobistego. Po pomyślnym przesłaniu sprawdzimy, czy wszystko jest w porządku, i prześlemy ci potwierdzenie lub kolejne kroki, aby ukończyć proces weryfikacji',

    'very strong': 'bardzo silne',
    verified: 'zweryfikowany',
    verify: 'zweryfikuj',
    'Verify Ticket': 'zweryfikuj kupon',
    'Verification in progress': 'weryfikacja w toku',
    virtual: 'wirtual',
    'virtual results': 'Wirtualne - wyniki',
    'virtual shops': 'Wirtualne PPZ',
    'virtual shops results': 'Wirtualne - wyniki PPZ',
    'virtual greyhound races': 'wirtualne wyścigi chartów',
    'virtual football league': 'Wirtualna piłka nożna',
    'virtual tennis open': 'Wirtualny tenis',
    'virtual motorcycle speedway': 'Wirtualny żużel',
    'virtual horse races': 'wirtualne wyścigi koni',
    'Virtual betting - Lucky six, Dog racing, Virtual sports': 'Zakłady wirtualne - Lucky six, Wyścigi psów, Sporty wirtualne',
    'Virtual games are currently under maintenance': 'Gry wirtualne są obecnie w trakcie konserwacji',
    'video not available': 'wideo niedostępne',
    'view the privacy statement': 'Zobacz oświadczenie o ochronie prywatności',
    visa: 'visa',
    'Video is pinned. You can see details for other events and still watch your pinned video.': 'Film jest przypięty. Możesz zobaczyć szczegóły innych wydarzeń i nadal oglądać przypięte wideo.',

    win: 'wygrana',
    'win without tax': 'Wygraj bez podatku:',
    won: 'wygrałęś',
    'Want to see all the offers?': 'Chcesz zobaczyć całą ofertę?',
    wednesday: 'środa',
    weak: 'słaby',
    'weekly offer': 'oferta tygodniowa',
    'weekly lotto offer': 'oferta tygodniowa lotto',
    welcome: 'witamy',
    'welcome bonus': 'bonus powitalny',
    'winning numbers': 'wygrywające liczby',
    'winning numbers (in their drawing order)': 'wygrane liczby (w kolejności losowania)',
    withdrawal: 'wypłata',
    'withdrawal error': 'brąd wypłaty',
    'wrong code': 'błędny kod',
    'By making this withdrawal, the active bonus on the account and the related winnings will be canceled':
        'Dokonując tej wypłaty, aktywny bonus na koncie i powiązane wygrane zostaną anulowane',
    'withdrawal request': 'Żądanie wypłaty',
    'wrong current password': 'złe bieżące hasło',
    'We will check identity based on the uploaded image. This process usually last up to 24 hours. After confirming identity, we will send you a confirmation. Do not hesitate to contact us via': 'Sprawdzimy tożsamość na podstawie przesłanego obrazu. Ten proces zwykle trwa do 24 godzin. Po potwierdzeniu tożsamości wyślemy ci potwierdzenie. Nie wahaj się skontaktować z nami za pośrednictwem',
    'we do not want you to lose your account and money': 'nie chcemy, abyś stracił swoje konto i pieniądze',
    'welcome to Favourites page! You don\'t have any favorite tournaments yet.': 'witamy na stronie Ulubionych! Nie masz jeszcze żadnych ulubionych turniejów.',
    'want to see all the offers': 'chcesz sobaczyć wszystkie oferty?',

    'your account': 'twoje konto',
    'registration.withdrawConsent': 'Możesz w dowolnym momencie wycofać zgodę na przetwarzanie swoich danych osobowych, uzyskując dostęp do konta klienta. Odstąpienie od umowy nie wpłynie na zgodność z prawem przetwarzania danych przeprowadzonego do czasu jej wycofania',
    'your bonus': 'twój bonus',
    'your stake': 'twoja stawka',
    'your password': 'twoje hasło',
    'Your password has been updated successfully. Now you can sign in with your new credentials.': 'Twoje hasło zostało zmienione poprawnie. Teraz możesz zalogować się przy użyciu nowych danych logowania.',
    'your profile details': 'szczegóły twojego profilu',
    'you must agree before submitting': 'musisz wyrazić zgodę przed przesłaniem',
    'you must activate your account': 'musisz aktywować swoje konto',
    'your account is now activated': 'towje konto jest teraz aktywne',
    'You should verify with SMS': 'Powinieneś zweryfikować za pomocą SMS-a',
    'You didn\'t receive the SMS': 'Nie otrzymałeś SMS-a',
    'You have sent the maximum number of SMS messages. If you wish to send more, please contact support': 'Wysłano maksymalną liczbę wiadomości SMS. Jeśli chcesz wysłać więcej, skontaktuj się z pomocą techniczną',
    'You can at any time withdraw your consent to the processing of personal data by accessing your client account. Withdrawal of the agreement will not affect the lawfulness of the data processing carried out until the agreement is withdrawn': 'Możesz w dowolnym momencie wycofać swoją zgodę na przetwarzanie danych osobowych, uzyskując dostęp do konta klienta. Odstąpienie od umowy nie wpłynie na zgodność z prawem przetwarzania danych przeprowadzonego do czasu jej wycofania',
    'you will be able to withdraw the funds after completing the verification process (after approximately 24 hours)': 'będziesz mógł wypłacić środki po zakończeniu procesu weryfikacji (po około 24 godzinach)',
    'You do not meet the withdrawal requirements. Please check your account information and try again.': 'Nie spełniasz warunków wypłaty. Sprawdź informacje o koncie i spróbuj ponownie.',
    'You first need to make a deposit before doing any withdrawals':
        'Najpierw musisz dokonać wpłaty przed dokonaniem jakichkolwiek wypłat',
    'You can play exactly 6 matches on the ticket. No system / double paid tickets can be played.': 'Na kuponie możesz zagrać dokładnie 6 meczów. Nie można zagrać w kupony systemowe / podwójnie opłacone.',
    'Your account has been activated! Enjoy your game': 'Twoje konto zostało aktywowane! Miłej gry',
    'You need to deposit to claim this bonus. Do not worry, you will be able to do this later': 'Musisz złożyć depozyt, aby otrzymać ten bonus. Nie martw się, będziesz mógł to zrobić później',
    'You will get a chance to choose your first deposit bonus. We have some extras to do this': 'Otrzymasz szansę wyboru bonusu od pierwszej wpłaty. Mamy na to kilka dodatków',
    'You must verify your account': 'Musisz zweryfikować swoje konto',
    'you can see your sports betting and lotto transactions.': 'możesz zobaczyć swoje zakłady sportowe i transakcje lotto.',
    'your stake is to small': 'twoja stawka jest za mała',
    'You are not allowed to add more than {maxSelectionForMarket} events from this type of market':
        'Nie możesz dodawać więcej niż {maxSelectionForMarket} wydarzeń z tego rodzaju zakładu',
    'You are not allowed to add more than one event from this type of market':
        'Nie możesz dodać więcej niż jednego wydarzenia z tego typu zakładu',
    'you must play exactly 6 events': 'musisz zagrać dokładnie 6 zdarzeń',
    'Your session has expired': 'towja sesja wygasła',
    'you must accept/decline ticket negotiation': 'musisz zaakceptować / odrzucić negocjację kuponu',
    'your stake is too big, maximal is {maximum}': 'Twoja stawka jest za duża, maksymalna to {maximum}',
    'your ticket is in preview mode': 'Twój kupon jest w trybie podglądu',
    'you do not have access to this page': 'nie masz dostępu do tej strony',
    'Your basic info so we know who you are': 'Podstawowe informacje o tobie, dzięki którym wiemy, kim jesteś',
    'Your ticket does not exist, check if ID is correct': 'Twój kupon nie istnieje, sprawdź, czy dowód tożsamości jest prawidłowy',
    'Your bet will be placed even if odds change in the meantime!': 'Twój zakład zostanie postawiony, nawet jeśli w międzyczasie zmieni się kurs!',
    'you can not place bets for this event anymore': 'nie możesz już stawiać zakładów na to wydarzenie',
    'quick deposit': 'szybka wpłata',
    'quota changed': 'kwota uległa zmianie',
    'You have been online for': 'Jesteś zalogowany przez',
    'privacy policy': 'polityka prywatności',
    'prepare bet': 'przygotuj zakład',
    'this page is not publicly avaliable': 'ta strona nie jest publicznie dostępna',
    'to access it please login first': 'aby uzyskać do niego dostęp, najpierw się zaloguj',
    'authorisation required': 'wymagana autoryzacja',
    'did you know': 'wiedziałeś',
    'that ”Federer” can be typed entirely with the left hand': 'że „Federer” można wpisać w całości lewą ręką',
    'roulette retail': 'ruletka detaliczna',
    'Next round unavailable.': 'Następna runda niedostępna.',
    'ticket ID': 'id kuponu',
    'Maximum number of favorites reached.': 'Osiągnięto maksymalną liczbę ulubionych.',
    warning: 'ostrzeżenie',
    '{char} is forbidden': '{char} jest zabronione',
    'Empty space is forbidden': 'Puste miejsce jest zabronione',
    quote: 'kwota',
    'withdrawal requirements': 'warunki wypłaty',
    'you have fields errors, please check the form': 'masz błędy pól, sprawdź formularz',
    'Frequently Asked Questions - Bonuses': 'Często zadawane pytania - bonusy',
    'date of birth': 'data urodzenia',
    'no thanks': 'nie dziękuję',
    'I want bonus': 'chcę bous',
    'welcomeBonus.sportBonus.intro': 'Ciesz się nowym kontem bukmacherskim online z ogromnym bonusem, który czeka na Ciebie',
    'You don\'t have any favorite games yet.': 'Nie masz jeszcze żadnych ulubionych gier.',
    'not valid date': 'niepoprawna data',
    'pick nationality': 'wybierz narodowość',
    'details of your residence for regulatory purposes': 'szczegóły twojego pobytu do celów prawnych',
    'PESEL number': 'numer PESEL',
    'country of residence': 'Kraj zamieszkania',
    'postal code': 'kod pocztowy',
    'choose source': 'wybierz źródło',
    'communication via SMS': 'komunikacja przez SMS',
    'communication via E-mail': 'komunikacja przez E-mail',
    'MM.DD.YYYY': 'MM.DD.RRRR',
    'DD/MM/YYYY': 'DD/MM/RRRR',
    cookies: 'cookies',
    cooperation: 'współpraca',
    'payment methods': 'metody płatności',
    'ABC player': 'ABC gracza',
    'payment-methods': 'metody-płatności',
    'careers-': 'kariera',
    'abc-player': 'vademecum-gracza',
    'cookies-': 'polityka-cookies',
    'cooperation-': 'wspolpraca-agencyjna',
    'PESEL is incorrect': 'PESEL jest nieprawidłowy',
    'Bank Account': 'Konto bankowe',
    'Polish bank account number': 'Numer konta bankowego',
    'Complete registration': 'Zakończ rejestrację',
    'customMarketingConsent.intro': 'Dla realizacji celów marketingowych wyrażam zgodę na otrzymywanie informacji handlowych i promocyjnych poprzez następujące ścieżki komunikacji elektronicznej',
    'ID or passport number': TRANSLATION_PENDING,
    SMS: TRANSLATION_PENDING,
    'You must choose either E-mail or SMS': TRANSLATION_PENDING,
    'It applies for minimum of 6 events with a minimum quota of 1.25': TRANSLATION_PENDING,
    next3H: '+3H',
    'kyc.intro': TRANSLATION_PENDING,
    'Search box must contain at least three letters': TRANSLATION_PENDING,
    strong: TRANSLATION_PENDING,
    superbets: 'Superbets',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/app/localization/lang/translations/translations.ts